import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50 text-slate-400 text-sm uppercase tracking-widest" data-testid="auth-loading">
        Loading...
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
